import {
  faPowerOff,
  faUserAlt,
  faUserNinja,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { Card, Switch, TaskBar, ValueList } from '.';
import config from '../config';
import theme from '../exports.module.scss';
import { User } from '../types';
import { attributionSource } from '../utilities/attribution';
import formatDate from '../utilities/format-date';
import './UserCard.scss';

type UserCardProps = {
  user: User;
  [key: string]: any;
};

export function UserCard({ user, ...props }: UserCardProps): ReactElement {
  return (
    <Card className="user-card" {...props}>
      <TaskBar
        left={
          <div>
            <h2>
              <FontAwesomeIcon icon={user.admin ? faUserNinja : faUserAlt} />
              <Link to={`/users/${user.id}`}>
                {user.displayName || 'Anonymous'}
              </Link>
            </h2>
            <ValueList
              values={{
                Id: user?.id ?? '',
                Created: user
                  ? formatDate(user.createdAt, config.pageDateFormat)
                  : '',
                'Last active':
                  user && user.lastActiveAt ? (
                    formatDate(user.lastActiveAt, config.pageDateFormat)
                  ) : (
                    <span className="extra">No activity</span>
                  ),
                // Only admins are sent this, so only admins see the row
                ...(user?.signupAttribution !== undefined && {
                  Source: attributionSource(user.signupAttribution),
                }),
              }}
            />
          </div>
        }
        right={
          <>
            <Switch
              name={`user-${user.id}-admin`}
              label="Admin"
              icon={faUserNinja}
              color={theme.intentDanger}
              value={user.admin}
              readonly
            />
            <Switch
              name={`user-${user.id}-activated`}
              label="Activated"
              icon={faPowerOff}
              color={theme.intentSuccess}
              value={user.activated}
              readonly
            />
          </>
        }
      />
    </Card>
  );
}
